import * as $ from 'jquery';
import {ResizeService} from "../../page-services/resize-service";

export class iframeFrontend {

    static init() {
        $(document).ready(() => {
            iframeFrontend.fixHeight();
        });
        ResizeService.subscribeStream(() => iframeFrontend.fixHeight());
    }

    static fixHeight() {
        $('.iframe').not('.dynamic').each((i, iframe) => {
            let $iframe = $(iframe);
            if (typeof $iframe.data('dh') != undefined && typeof $iframe.data('th') != undefined && typeof $iframe.data('mh') != undefined) {
                let windowWidth = $(window).width();
                if(windowWidth > 991) {
                    $iframe.css('height', $iframe.data('dh') + 'px');
                } else if (windowWidth > 575) {
                    $iframe.css('height', $iframe.data('th') + 'px');
                } else {
                    $iframe.css('height', $iframe.data('mh') + 'px');
                }
            }
        })
    }
}